import React from 'react';
import DocumentosVersionadosPage from "../../components/documentos/DocumentosVersionadosPage";
import AdicionarPolitica from "./components/AdicionarPolitica";

function PoliticaDePrivacidade() {
    return (
        <DocumentosVersionadosPage
            title="Política de Privacidade"
            subtitle="Histórico de versões da política de privacidade."
            listEndpoint="listarPoliticas"
            responseKey="politicas"
            getId={(politica) => politica?.idPolitica}
            addLabel="Nova versão"
            emptyMessage="Nenhuma política de privacidade encontrada."
            renderAddDialog={({ open, onClose }) => (
                <AdicionarPolitica adicionarPolitica={open} setAdicionarPolitica={(value) => !value && onClose()} />
            )}
        />
    );
}

export default PoliticaDePrivacidade;
